import { createContext, useContext } from "react";

export interface RowSelectionStore {
  getSelection: () => ReadonlySet<string>;
  getSelectionCount: () => number;
  isSelected: (id: string) => boolean;
  subscribe: (listener: () => void) => () => void;
  toggle: (id: string) => void;
  toggleMany: (ids: string[]) => void;
  clear: () => void;
}

export interface RowSelectionContextValue {
  store: RowSelectionStore;
}

export const RowSelectionContext =
  createContext<RowSelectionContextValue | null>(null);

export const useRowSelectionContext = () => {
  const context = useContext(RowSelectionContext);
  if (!context) {
    throw new Error(
      "useRowSelectionContext must be used within a RowSelectionProvider",
    );
  }
  return context;
};
